export default "__VITE_ASSET__Dyvew7uG__"